var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.field.label},model:{value:(_vm.block.data[_vm.field.varname]),callback:function ($$v) {_vm.$set(_vm.block.data, _vm.field.varname, $$v)},expression:"block.data[field.varname]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }